import { SERVICE } from '@src/api/types/shared/serviceType';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import ArticleEditorForm from '@src/features/tenant/articles/ArticleEditorForm';
import TenantWithoutSideBarLayout from '@src/layouts/tenant/TenantWithoutSideBarLayout';

function ArticleForm() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL]}
    >
      <TenantWithoutSideBarLayout>
        <ArticleEditorForm />
      </TenantWithoutSideBarLayout>
    </TenantRoleGuard>
  );
}

export default ArticleForm;
